import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import type {RouteLocation, Router} from 'src/types/router';
import type {UpdateOptions} from 'src/utils/analytics-query';

import * as React from 'react';
import {useHistory} from 'src/rerouter';
import hoistNonReactStatics from 'hoist-non-react-statics';

import {parseQuery, updateQuery} from 'src/utils/analytics-query';


export type AnalyticsQueryProps = {
  query: Record<any, any>;
  onQueryChange: (update: Record<any, any>, options: UpdateOptions) => void;
  router: Router;
  location: RouteLocation;
};

function withAnalyticsQuery<C>(
  WrappedComponent: React.ComponentType<C>,
  // @ts-expect-error - TS2344 - Type 'C' does not satisfy the constraint 'AnalyticsQueryProps'.
): React.ComponentType<Flow_Diff<C, AnalyticsQueryProps>> {
  const WithAnalytics = (props: any) => {
    const router = useHistory();
    const {location} = router;
    const {
      query: {q},
    } = location;
    const query = parseQuery(q);
    const handleQueryChange = (
      update: Record<any, any>,
      options: UpdateOptions = {},
    ) => {
      let newQ = q;
      if (options.entityDataFilter && !query.edf) {
        newQ = updateQuery(newQ, {edf: {$set: {}}});
      }
      newQ = updateQuery(newQ, update, options);
      router.push({
        ...location,
        query: {
          ...location.query,
          q: newQ,
        },
      });
    };
    return (
      <WrappedComponent
        {...props}
        router={router}
        location={location}
        query={query}
        onQueryChange={handleQueryChange}
      />
    );
  };
  return hoistNonReactStatics(WithAnalytics, WrappedComponent);
}

export default withAnalyticsQuery;
